import * as React from 'react';
import {Row, Col, Button, ControlLabel, HelpBlock} from 'react-bootstrap';
import { flow } from 'lodash';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as quoteActions } from '../../../../../../services/quote/reducer';
import { IStore } from '../../../../../../redux/IStore';
import FaSpinner from '../../../../../../components/PostcodeControl';
import { IActivities } from '../../../../../../data/api/models';
import Select from 'react-select';
import FaTimesCircle from 'react-icons/fa/times-circle';

interface IActivitiesProps {
    attributes: {
        name: IActivities,
    };
    id: string;
    onSelectActivity(activities: any): void;
    renderDefinition(name: string): any;
    dispatch: any;
    change: any;
    activities: string[];
    productActivities: any;
}

class ActivitiesSelect extends React.Component<IActivitiesProps> {
    public state = {
        isSearching: false,
        activities: [],
        activity: '',
        selectedActivities: [],
    };
    public componentDidMount() {
        const { productActivities } = this.props;

        this.setState({
            isSearching: false,
            activities: productActivities,
        });

        if (this.props.activities && this.props.activities.length > 0) {
            this.setState({ selectedActivities: this.props.activities });
        }
    }

    private selectActivities = (newValue) => {

        if (newValue) {
            this.setState({
                activity: newValue,
            });
        }
    }

    private addSelectedActivity = (value) => () => {
        const { onSelectActivity } = this.props;
        const { selectedActivities } = this.state;

        if ((value.value !== '' && !selectedActivities.includes(value.value)) && selectedActivities.length < 10) {
            selectedActivities.push(value.value);
            this.setState({selectedActivities});
            onSelectActivity(selectedActivities);
            this.setState({
                activity: '',
            });
        }
    }

    private handleDelete = (value) => () => {
        const { onSelectActivity } = this.props;
        const { selectedActivities } = this.state;

        if (selectedActivities.length > -1) {
            selectedActivities.splice(value, 1);
            this.setState({selectedActivities});
            onSelectActivity(selectedActivities);
        }
    }

    public render() {
        const { meta } = this.props;
        const { isSearching, activities, activity, selectedActivities } = this.state;

        const list = (activities || []).map((activity: IActivitiesProps) => ({
            label: activity,
            value: activity,
        }));

        return (
            <div>
                <Row>
                    <Col sm={3} />
                    <Col sm={9}>
                        <p>What activities do you require cover for? You can add up to 10 activities.
                            Please note some activities may be limited to specific destinations:</p>
                    </Col>
                </Row>
                <Row>
                    <Col sm={3}>
                        <ControlLabel>
                            Activities: {/*this.props.renderDefinition('activities')*/}
                        </ControlLabel>
                    </Col>
                    <Col sm={9}>
                        <Row>
                            <div className={meta.touched && meta.error ? 'has-error' : ''}>
                                <Col sm={9}>
                                    <br />
                                    <Select
                                        type="text"
                                        value={activity.value ? activity.value : ''}
                                        options={list}
                                        placeholder="Search For..."
                                        onChange={this.selectActivities}
                                        clearable={false}
                                        style={{ bottom: '24px' }}
                                    />
                                </Col>
                                <Col sm={3}>
                                    <Button
                                        bsStyle="primary"
                                        className="btn-postcode"
                                        type="button"
                                        disabled={!activity.value}
                                        onClick={this.addSelectedActivity(activity)}
                                    >
                                        {isSearching
                                            ? (<FaSpinner className="fa-spin"/>)
                                            : <span>Add</span>}
                                    </Button>
                                </Col>
                                {meta.touched && meta.error && <HelpBlock>{meta.error}</HelpBlock>}
                            </div>
                        </Row>
                    </Col>
                </Row>
                {selectedActivities && selectedActivities.length > 0 && (
                    <Row>
                        <Col sm={3} />
                        <Col sm={9}>
                            {selectedActivities.map((selectedActivity, key) => {
                                return (
                                    <div key={key}>
                                        {selectedActivity}{' '}
                                        <FaTimesCircle onClick={this.handleDelete(key)} className="fa-times-circle" />
                                        <br />
                                    </div>
                                );
                            })}
                        </Col>
                    </Row>
                )}
            </div>
        );
    }
}

let selector;

export default flow([
    (component) => {
        selector = formValueSelector('quote');
        return component;
    },
    connect(
        (state: IStore) => {
            const activities = selector(state, 'activities');
            return {
                activities,
            };
        },
        (dispatch) => ({
            actions: {
                quote: bindActionCreators({...quoteActions}, dispatch),
            },
        }),
    ),
])(ActivitiesSelect);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetails/components/ActivitiesSelect/ActivitiesSelect.tsx